<template>
  <div>
    <b-modal
      id="modal-detail"
      size="lg"
      centered
      scrollable
      :title="title"
      header-bg-variant="primary"
      header-text-variant="light"
      @show="showModal"
    >
      <!-- <template #header>
        <h5 class="mb-0" style="color: #fff">
          <strong>{{ $store.state.table.laporanLembur }}</strong>
        </h5>
      </template> -->
      <!-- <CRow>
        <CCol cols="12" md="12" lg="12">
          <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
            <CIcon name="cil-plus" />
            {{ $store.state.table.tambahModal }}
          </b-button>
        </CCol>
      </CRow> -->
      <CRow>
        <CCol>
          <CDataTable
            :items="items"
            :fields="fields"
            responsive
            sorter
            column-filter
            hover
            show-empty
            :loading="loading"
            @update:column-filter-value="onFilter($event)"
          >
            <template #namaTanggalPengajuanLembur-filter>
              <date-picker
                style="width: 100%"
                v-model="filter.tanggalPengajuanLembur"
                format="DD MMMM YYYY"
              ></date-picker>
            </template>
            <template #jumlahJamLembur-filter>
              <b-form-select
                v-model="filter.jumlahJamLembur"
                  :options="optionsJam"
              ></b-form-select>
            </template>
            <!-- <template #Actions="{ item }">
              <td>
                <b-button
                  variant="info"
                  class="mr-1"
                  v-c-tooltip.hover.click="'Detail Data'"
                  v-b-modal.modal-detail
                  @click="
                    (dataLembur = item),
                    (detail = !detail),
                    (dataLembur.bulan = bulan),
                    (dataLembur.tahun = tahun)
                  "
                ><CIcon name="cil-info" /></b-button>
              </td>
            </template> -->
          </CDataTable>
          <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
        </CCol>
      </CRow>
    </b-modal>
  </div>
</template>

<script>

export default {
  components: {
  },
  name: "laporanLembur",
  props: [ 'data', ],
  data() {
    return {
      title: null,
      // data: {},
      listKaryawan: [],
      listMasterLembur: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        // {
        //   key: "namaKaryawan",
        //   label: "Karyawan",
        //   _style: "width: 30%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "namaTanggalPengajuanLembur",
          label: "Tanggal",
          _style: "width: 50%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jumlahJamLembur",
          label: "Jam Lembur",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaNominalLembur",
          label: "Nominal Lembur",
          _style: "width: 40%;",
          sortDirection: "desc",
          class: "text-left",
          filter: false,
          sorter: false,
        },
        // {
        //   key: "Actions",
        //   label: "Actions",
        //   _style: "width: 15%;",
        //   class: "table-option-2 text-center",
        //   filter: false,
        //   sorter: false,
        // },
      ],
      filter: {
        tanggalPengajuanLembur: null,
        statusPengajuan: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPengajuan: [
        { value: '0', text: "Butuh Persetujuan" },
        { value: '1', text: "Telah Disetujui" },
        { value: '2', text: "Ditolak" },
      ],
      optionsJam: [
        { value: null, text: "Pilih" },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
        { value: '6', text: '6' },
        { value: '7', text: '7' },
        { value: '8', text: '8' },
      ]
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    // this.getDatas();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    'filter.tanggalPengajuanLembur'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    'filter.statusPengajuan'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async showModal(){
      const vm = this
      // console.log(vm.data)
      vm.title = "Daftar Lembur Karyawan a.n " + vm.data.namaKaryawan;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPengajuanLembur = await vm.$axios.post("/pengajuanLembur/listPerHalaman", {
        ...vm.filter,
        tanggalPengajuanLembur: vm.filter.tanggalPengajuanLembur ? vm.$moment(vm.filter.tanggalPengajuanLembur).format('YYYY-MM-DD') : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        statusPengajuan: '1',
        dataKaryawanId: vm.data.dataKaryawanId,
      });
      console.log("listPengajuanLembur", listPengajuanLembur);
      vm.items = listPengajuanLembur.data.status == 200 ? listPengajuanLembur.data.data.map((x, idx) => { 
        return {
          ...x,
          //view
          no: (vm.currentPage - 1) * vm.perPage + idx + 1,
          namaTanggalPengajuanLembur: vm.$moment(x.tanggalPengajuanLembur).format('LL'),
          namaNominalLembur: vm.toNumeric(x.nominalLembur, 'idr'),
        }
      }): [];
      vm.totalRows = parseInt(listPengajuanLembur.data.count);
      vm.loading = false;
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({name, data}){
      this[name] = data
    },
    toNumeric(number, type){
      let data = {}
      if(type == 'no-idr') {
        return new Intl.NumberFormat('id-ID', {style: 'currency', currency: 'IDR'}).format(number).slice(3)
      }else{
        if(type == 'idr') data = {style: 'currency', currency: 'IDR'}
        return new Intl.NumberFormat('id-ID', data).format(number)
      }
    },
  },
};
</script>
